import { styled, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import {
  pink,
  green,
  cyan,
  purple,
  blueGrey,
  orange,
} from '@mui/material/colors';
import PropTypes from 'prop-types';

const StyledChip = styled(Chip)(({ extcolor, theme }) => {
  const style = {
    solrPlugin: {
      borderColor: purple[500],
      color: purple[500],
    },
    solrDictionary: {
      borderColor: green[500],
      color: green[500],
    },
    solrCollectionConfig: {
      borderColor: cyan[700],
      color: cyan[700],
    },
    solrModel: {
      borderColor: orange[700],
      color: orange[700],
    },
    data: {
      borderColor: pink[500],
      color: pink[500],
    },
    misc: {
      borderColor: blueGrey[600],
      color: blueGrey[600],
    },
  };
  return {
    ...style[extcolor],
    height: theme.spacing(3),
    marginBottom: 3,
  };
});

const Badge = ({ label, color, ...restProps }) => {
  return (
    <StyledChip
      variant="outlined"
      extcolor={color}
      label={<Typography variant="caption">{label}</Typography>}
      {...restProps}
    />
  );
};

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default Badge;
